import * as decodeJwt from 'jwt-decode';
import authenticationApiClient from '../auth/authenticationApiClient';
import { logger } from '@soluto-home-web/platform-utils';
import { logIn, isTokenValid } from './loginSession';

export default async function setFromFirebaseToken(jwt): Promise<void> {
  if (!isTokenValid(jwt)) return;

  const payload = decodeJwt(jwt, { json: true });
  try {
    const homeAccessToken = await authenticationApiClient.homeUserAccessTokenFromMessagingGrant(jwt);
    await logIn(homeAccessToken);
  } catch (e) {
    logger.error('Failed in setFromFirebaseToken', e, {
      HomeUserId: payload.claims.HomeUserId
    });
  }
}



// WEBPACK FOOTER //
// ./packages/platform-core/identity/setFromFirebaseToken.ts